<template>

    <section :id="component.identifier ? component.identifier : ''" class="jobtoolz__exhibition" v-if="show" :class="[ containerMarginBottom ]">

        <component-header :title="title" :description="description"></component-header>

        <div class="site__container" :class="[ containerTopPadding ]">
            <ul
                class="flex flex-wrap justify-center -mx-32 -mt-32"
                :class="[ containerHorizontalPadding ]"
                ref="container"
            >
                <li
                    v-for="(award, index) in component.awards"
                    :key="'award-' + award.id"
                    class="px-32 pt-32 rounded"
                    :class="[ exhibitContainerWidth ]"
                >
                    <div class="pt-100pct relative">
                        <div class="absolute inset-0">
                            <div class="h-full w-full flex items-center justify-center">
                                <a
                                    v-if="award.url"
                                    :href="award.url"
                                    class="jobtoolz__exhibition__exhibit hover:opacity-50 trans-ease h-full w-full flex items-center justify-center"
                                >
                                    <img
                                        :src="award.image_url + '&w=300&fit=max'"
                                        :alt="award.name"
                                        :title="award.name"
                                        class="max-h-full max-w-full"
                                    >
                                </a>

                                <img
                                    v-else
                                    :src="award.image_url + '&w=300&fit=max'"
                                    :alt="award.name"
                                    :title="award.name"
                                    class="jobtoolz__exhibition__exhibit max-h-full max-w-full"
                                >
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

    </section>

</template>

<script>
import ComponentHeader from './ComponentHeader.vue';
import { responsive, runningInBrowser } from '../../helpers';
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding'

export default {
    components: {
        'component-header': ComponentHeader,
    },
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {
            style: 'grid',
        }
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        ...mapState(useBrandingStore, ['preview']),
        show () {
            return runningInBrowser() || this.hasContent;
        },
        hasContent () {
            return this.component.awards && !!this.component.awards.length;
        },
        exhibitContainerWidth () {
            return responsive(this.preview.type, 'w-1/2 sm:w-1/3 md:w-1/5 lg:w-1/6');
        },
        containerHorizontalPadding () {
            return responsive(this.preview.type, 'px-32 lg:px-0');
        },
        containerTopPadding () {
            return responsive(this.preview.type, 'md:pt-16');
        },
        containerMarginBottom () {
            return responsive(this.preview.type, 'sm:mb-32 mb:mb-48 lg:mb-64');
        },
        title: {
        	get () {
        	    return this.translated(this.component.title)
        	}
        },
        description: {
        	get () {
                return this.translated(this.component.description)
        	}
        }
    },
    mounted () {
        this.$emit('loaded');
    }
}
</script>

<style scoped>
.grayscale:hover {
    filter: grayscale(100%);
}
</style>
